import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: '/api/',
  baseURL: 'https://admin-tucheze-dbhtoztfya-bq.a.run.app/api/v1/admin/',
  // baseURL: 'http://localhost:8000/api/v1/admin/',
  timeout: 9000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
